import React from "react";
import { useDispatch, useSelector } from "react-redux";

// Material UI Components
import Badge from "@mui/material/Badge";

//  Material UI Icons
import TuneIcon from "@mui/icons-material/Tune";

// Components
import Button from "components/buttons/Button/Button.component";

import { inventoryReducer } from "reducers/inventory-reducer";
import usePageWidth from "hooks/usePageWidth.hook";
import useInventoryFilters from "hooks/inventory/useInventoryFilters.hook";

// Styles
import { useStyles } from "./FilterModalButton.styles";

const FilterModalButton = ({ buttonLabel }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { isDesktopWidth } = usePageWidth();
  const { filterCount } = useInventoryFilters();
  const loading = useSelector((s) => s.inventory.loading);

  const handleClickOpen = () => {
    dispatch(inventoryReducer.actions.setFilterModalOpen(true));
  };

  return (
    <Badge
      badgeContent={isDesktopWidth ? filterCount : 0}
      color="primary"
      className={classes.moreFiltersContainer}
    >
      <Button
        data-cy="more-filters-button"
        classes={{ label: classes.buttonLabel }}
        variant={isDesktopWidth ? "outlined" : "contained"}
        disabled={loading.filters}
        onClick={handleClickOpen}
        endIcon={
          !isDesktopWidth && filterCount ? (
            <Badge
              badgeContent={filterCount}
              classes={{ badge: classes.customWhiteBadge }}
              className={classes.filterCountBadge}
            />
          ) : undefined
        }
        size="md"
        startIcon={isDesktopWidth && <TuneIcon />}
      >
        {buttonLabel}
      </Button>
    </Badge>
  );
};

export default FilterModalButton;
